import { getProblemTotalsStats } from 'frontend/communications/stats'

const stateObj = {
  problemTotalStats: [],
}

const getters = {
  getProblemTotalStats (state) {
    return state.problemTotalStats
  },
}

const mutations = {
  setProblemTotalStats (state, value) {
    state.problemTotalStats = value
  },
}
const actions = {
  async fetchProblemStats ({ commit }, payload) {
    const response = await getProblemTotalsStats(
      payload['perimeterIds'],
      payload['from'],
      payload['to'],
      payload['frequency']
    )
    commit('setProblemTotalStats', response)
    return response
  },
  resetProblemStats ({ commit }) {
    commit('setProblemTotalStats', null)
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
